import dayjs from "dayjs";

export const required = (message?: string) => {
  return (v: unknown) => !!v || message || "Campo obrigatório";
};

export const requiredValidZero = () => {
  return (v: unknown) => (v != undefined ? true : false) || "Campo obrigatório";
};

export const tamCampo = (numero: number, mensagem?: string) => {
  return (v: any) =>
    ((v?.length ?? 0) >= numero ? true : false) ||
    (mensagem ? mensagem : `Campo deve ser maior ou igual ${numero}`);
};

export const validDate = () => {
  const pattern = /^$|[0-3]?[0-9].[0-3]?[0-9].(?:[0-9]{2})?[0-9]{4}$/;
  return (v: string) => (pattern.test(v) ? true : false) || "Data Inválida";
};

export const validDateDayMonth = () => {
  const pattern = /^(0[1-9]|[12][0-9]|3[01]).(0[1-9]|1[012])|(.[12][0-9]{3})$/;
  return (v: string) => (pattern.test(v) ? true : false) || "Data Inválida";
};

export const validPeriod = () => {
  const pattern =
    /^([1-9]|0[1-9]|[1,2][0-9]|3[0,1])\/(0[1-9]|1[0,1,2])\/\d{4}-([1-9]|0[1-9]|[1,2][0-9]|3[0,1])\/(0[1-9]|1[0,1,2])\/\d{4}$/;
  return (v: string) =>
    (pattern.test(v.replace(/ /g, "")) ? true : false) || "Período Inválido";
};

export const rangeDateIsValid = (days: number) => {
  return (v: string) =>
    !v.split(" ", 3)[2] ||
    !v.split(" ", 3)[0] ||
    (dayjs(
      v.split(" ", 3)[2].substring(6, 12) +
        "-" +
        v.split(" ", 3)[2].substring(3, 5) +
        "-" +
        v.split(" ", 3)[2].substring(0, 2),
    ).diff(
      dayjs(
        v.split(" ", 3)[0].substring(6, 12) +
          "-" +
          v.split(" ", 3)[0].substring(3, 5) +
          "-" +
          v.split(" ", 3)[0].substring(0, 2),
      ),
      "day",
    ) <= days
      ? true
      : false) ||
    `O intervalo das datas tem que ser inferior a ${days} dias.`;
};

export const maiorQue = (numero: number) => {
  return (v: unknown) => {
    if (!v) {
      return true;
    }

    return (
      (Number(v) > numero ? true : false) ||
      `Campo deve ser maior que ${numero}`
    );
  };
};

export const porcentagem = () => {
  return (v: unknown) =>
    (!v || (Number(v) >= 0 && Number(v) <= 100) ? true : false) ||
    `Campo deve estar entre 0 e 100`;
};

export const vetorVazio = () => {
  return (v: unknown) => {
    if (Array.isArray(v)) {
      if (v.length == 0) {
        return "Selecione uma opção";
      }
    }
    return true;
  };
};

export const validEmail = () => {
  const pattern =
    /^$|(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return (v: string) => (pattern.test(v) ? true : false) || "Email Inválido";
};

export const validHora = () => {
  const pattern = /^([0-1][0-9]|[2][0-3])(:([0-5][0-9])){1,2}$/;
  return (v: string) => (pattern.test(v) ? true : false) || "Hora Inválida";
};

export const validTel = () => {
  return (v: string) => {
    if (!v) return true;
    const digits = v.replace(/\D/g, "");
    if (digits.length === 0) return true;
    return digits.length === 10 || digits.length === 11 || "Número de telefone inválido";
  };
};

export const inteiroNaoNegativo = () => {
  return (v: unknown) => {
    if (v === null || v === undefined || v === "") {
      return true;
    }

    return (
      (Number.isInteger(Number(v)) && Number(v) >= 0) ||
      "Informe um número inteiro maior ou igual a zero"
    );
  };
};

export const validSlug = () => {
  const pattern = /^[a-z0-9_-]+$/;
  return (v: string) =>
    (!v || pattern.test(v) ? true : false) ||
    "Slug deve conter apenas letras minúsculas, números, hífen ou underscore";
};
